import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as d from "../../../reducers/domainReducer";

class Footer extends React.Component {
    constructor(props) {
        super(props);        
    }   

    render() {
        const { bundle, isProxyUser, currentPharmacyUser, applicationVersion, technicalHelpDeskNumber, technicalHelpDeskHours, showAssistanceLink, fixBottom, currentYear } = this.props;
        let isClientSide = typeof window !== 'undefined';
        let showFooterLinks = bundle === "mybswhealth" || (bundle === "pharmacy" && !currentPharmacyUser);                 
        return (
            <div className={`container-fluid footer-container footer-loggedin ${fixBottom}`}>
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="row">
                            {showAssistanceLink && <div className="col-12 footer__links">
                                <p>Call the MyBSWHealth technical help desk {technicalHelpDeskHours} at <a href={"tel:" + technicalHelpDeskNumber} className="phone-link">{technicalHelpDeskNumber}</a>.</p>
                            </div>}
                            {isClientSide && 
                            <div className="col-12 col-md-7 col-lg-8 footer__links">
                                {showFooterLinks && 
                                    <React.Fragment>
                                        <Link to={{ pathname: "/terms" }}>
                                            Terms of Use
                                        </Link>
                                        <Link to={{ pathname: "/privacy" }}>
                                            Privacy Policy
                                        </Link>
                                        <Link to={{ pathname: "/disclosures" }}>
                                            Disclosure Statements
                                        </Link>
                                        <Link to={{ pathname: "/customerservice" }}>
                                            Customer Service
                                        </Link>  
                                    </React.Fragment>
                                  }
                            </div>
                            }
                            <div className="col-12 col-md-5 col-lg-4 footer__copyright">
                                <div className="copyright">© {currentYear} All Rights Reserved</div>
                                <div className="mychart-copyright">Version: {applicationVersion}</div>
                                {/*<div className="mychart-copyright">MyChart® Epic System Corporation</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        technicalHelpDeskNumber: state.session.serverData.technicalHelpDeskNumber,  
        technicalHelpDeskHours: state.session.serverData.technicalHelpDeskHours,
        //thrive: state.header.thrive, 
        bundle: state.session.serverData ? state.session.serverData.bundle : "mybswhealth",  // we'll default with rendering for mybswhealth
        isProxyUser: state.domain.ip,
        currentYear: state.session.serverData && state.session.serverData.currentYear ? state.session.serverData.currentYear : "2021",
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
        applicationVersion: state.session.serverData ? state.session.serverData.applicationVersion : "1.0.0.0",  // we'll default with rendering for mybswhealth
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect( mapStateToProps, mapDispatchToProps)(Footer);